import styles from "./local-nav.style.scss?raw";
import { i18n, LANGUAGES } from "./internationalize/i18n.service";

export class LocalNavComponent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // Inject styles into the document head
        if (!document.getElementById('local-nav-styles')) {
            const styleElement = document.createElement('style');
            styleElement.id = 'local-nav-styles';
            styleElement.textContent = styles;
            document.head.appendChild(styleElement);
        }

        this.innerHTML = `
        <tbw-auth-state>
            <div slot="premium">
                <nav>
                <h1>The Big Whale</h1>
                <div class="nav-links-container">
                    <div class="search-wrapper">
                        <tbw-global-search-opener></tbw-global-search-opener>
                    </div>
                    <tbw-dark-mode-switcher></tbw-dark-mode-switcher>
                    <button id="lang-switcher-btn" class="lang-switcher"></button>
                    <button id="auth-btn">Trigger authChange Event</button>
                    <button id="test-btn">Trigger test Analytics Event</button>
                    <button id="clear-context-btn">Clear Context</button>
                    <tbw-signout-btn></tbw-signout-btn>
                </div>
                <ul>
                    <li><a class="nav-link" href="/">Home</a></li>
                    <li><a class="nav-link" href="/src/tests/auth-user-profile.html">Profile</a></li>
                    <li><a class="nav-link" href="/src/tests/newsletter.html">Newsletters</a></li>
                    <li><a class="nav-link" href="/src/tests/token-data.html">Token Data</a></li>
                    <li><a class="nav-link" href="/src/tests/asset-screener.html">Asset Screener</a></li>
                    <li><a class="nav-link" href="/src/tests/homepage.html">Homepage</a></li>
                    <li><a class="nav-link" href="/src/tests/payments.html">Payments</a></li>
                    <li><a class="nav-link" href="/src/tests/test-from-deployed.html">FROM DEPLOYED</a></li>
                    <li><a class="nav-link" href="/src/tests/charts-tests.html">Charts Tests</a></li>
                    <li><a class="nav-link" href="/src/tests/numbers-tests.html">Numbers Tests</a></li>
                    <li><a class="nav-link" href="/src/tests/news-tests.html">News Tests</a></li>
                    <li><a class="nav-link" href="/src/tests/bubbles-tests.html">Bubbles Test</a></li>
                    <li><a class="nav-link" href="/src/tests/pie-chart-test.html">Pie Chart Test</a></li>
                    <li ><a class="nav-link" href="/src/tests/table-chart-test.html">Table Chart Test</a></li>
                    <li><a class="nav-link" href="/src/tests/login.html">Login</a></li>
                    <li><a class="nav-link" href="/src/tests/article-en/briefing-the-state-of-the-crypto-market-in-q3-2025.html">EN article</a></li>
                    <li><a class="nav-link" href="/src/tests/article/briefing---letat-du-marche-crypto-au-3eme-trimestre-2025.html">FR article</a></li>
                    <li><a class="nav-link" href="/src/tests/report-embed.html">Report Embed</a></li>
                </ul>
                <ul>
                    <li><a class="nav-link" href="/src/tests/dashboards/bitcoin.html">Bitcoin Dashboard</a></li>
                    <li><a class="nav-link" href="/src/tests/dashboards/etfs.html">ETFs Dashboard</a></li>
                    <li><a class="nav-link" href="/src/tests/dashboards/ethereum.html">Ethereum Dashboard</a></li>
                    <li><a class="nav-link" href="/src/tests/dashboards/tokenization.html">Tokenization Dashboard</a></li>
                    <li><a class="nav-link" href="/src/tests/dashboards/stablecoins.html">Stablecoins Dashboard</a></li>
                    <li><a class="nav-link" href="/src/tests/dashboards/tradfi-defi.html">Tradfi & DeFi Dashboard</a></li>
                    <li><a class="nav-link" href="/src/tests/dashboards/new-charts.html">New Charts</a></li>
                </ul>
            </nav>
            </div>
            <div slot="visitor">
                hi visitor
            </div>
        </tbw-auth-state>
        `;

        // Set active state based on current page
        this.setActiveNavItem();
        this.createAuthTriggerButton();
        this.createLanguageSwitcher();
        this.createTestAnalyticsTriggerButton();
        this.createTestAnalyticsClearContextButton();
    }

    createAuthTriggerButton(): void {
        const authBtn = this.querySelector('#auth-btn') as HTMLButtonElement;
        authBtn?.addEventListener('click', function () {
        //   console.log('click auth btn')
          const customEvent = new CustomEvent('authChange', {
            detail: { authenticated: true },
            bubbles: true,
            cancelable: true
          });
        
          document.dispatchEvent(customEvent);
        });
    }

    createTestAnalyticsTriggerButton(): void {
        const authBtn = this.querySelector('#test-btn') as HTMLButtonElement;
        authBtn?.addEventListener('click', () => {
            window.tbwServices.analyticsService.track('test')
        });
    }

    createTestAnalyticsClearContextButton(): void {
        const clearContextBtn = this.querySelector('#clear-context-btn') as HTMLButtonElement;
        clearContextBtn?.addEventListener('click', () => {
            window.tbwServices.analyticsService.clearUserContext()
        });
    }

    createLanguageSwitcher(): void {
        const langBtn = this.querySelector('#lang-switcher-btn') as HTMLButtonElement;
        if (!langBtn) return;

        // Update button text based on current language
        const currentLang = localStorage.getItem('wglang')
        langBtn.textContent = currentLang === LANGUAGES.EN ? '🇬🇧 EN' : '🇫🇷 FR';

        // Handle language switching
        langBtn.addEventListener('click', () => {
            const currentLang = i18n.getLanguage();
            const targetLang = currentLang === LANGUAGES.FR ? LANGUAGES.EN : LANGUAGES.FR;
            if (window.tbwServices.weglotService.isReady()) {
                // Use Weglot service if available (production)
                window.tbwServices.weglotService.switchTo(targetLang);
                // weglotService will trigger language change event, which triggers reload
            } else {
                // Fallback for local development
                console.info('Weglot not available. Using localStorage fallback for local dev.');
                localStorage.setItem('wglang', targetLang);
                window.location.reload();
            }
        });
    }

    private setActiveNavItem(): void {
        const currentPath = window.location.pathname;
        const aList = this.querySelectorAll('a');
        aList.forEach(a => {
            const href = a.getAttribute('href');
            if (href) {
                // Handle home page case
                if (currentPath === '/' && href === '/') {
                    a.classList.add('active');
                }
                // Handle other pages
                else if (currentPath.includes(href) && href !== '/') {
                    a.classList.add('active');
                }
            }
        });
    }
}